export default {
  pages: {
    alifshopOffersShow: {
      toToStockLink: "Omborga o'tish",
    },
  },
};
